module.exports = __webpack_public_path__ + "img/pop-up-call.269c03ca.svg";